import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await authService.register(username, password, fullName);
      navigate('/login');
    } catch (requestError: any) {
      setError(requestError.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell auth-shell">
      <div className="auth-panel card">
        <p className="eyebrow">Register</p>
        <h1 className="page-heading auth-heading">Create your GLSN member account</h1>
        <p className="page-copy auth-copy">New accounts are created as members. An owner assigns roles and configures which capabilities each role receives.</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="compose-form">
          <div className="form-group">
            <label className="form-label" htmlFor="full_name">Full name</label>
            <input id="full_name" className="form-input" value={fullName} onChange={(event) => setFullName(event.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="username">Username</label>
            <input id="username" className="form-input" value={username} onChange={(event) => setUsername(event.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="password">Password</label>
            <input id="password" type="password" className="form-input" value={password} onChange={(event) => setPassword(event.target.value)} required />
          </div>
          <div className="action-row">
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Creating account...' : 'Register'}</button>
          </div>
        </form>

        <p className="auth-footer">Already have an account? <Link to="/login">Sign in</Link></p>
      </div>
    </div>
  );
};

export default RegisterPage;
